import { I18n } from '@/i18n/I18n';

export const TERMS_AND_CONDITIONS_URL = 'https://www.fusaware.com/license-and-services-agreement';

export function TermsAndConditionsNotice({ description }: { description: string }) {
  return (
    <p className="text-muted small mb-0">
      {description}{' '}
      <a href={TERMS_AND_CONDITIONS_URL} target="_blank" rel="noopener noreferrer">
        {I18n.get('termsAndConditionsLink')}
      </a>.
    </p>
  );
}
